<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="codeTasks" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="codeTaskId" selectionMode="single"
  [(selection)]="codeTask" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (outlineNewButton) {
        <h1 style="float: left;margin: 0px;">Code Tasks</h1>
      }
      @if (!outlineNewButton) {
        <h6 style="float: left;">Code Tasks</h6>
      }
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New CodeTask +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    @if (recordTotal>0) {
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
    @if (recordTotal<1) {
      <tr><td>No Record Found.</td>
    </tr>
  }
  @if (showFilter) {
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'taskName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'assignedTo', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'category', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'priority', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'assignedDate', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'completedDate', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'hours', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-codeTask>
  @if (codeProjectId && (codeProjectId == codeTask.codeProjectId)) {
    <tr [pSelectableRow]="codeTask">
      <td>{{codeTask.taskName}}</td>
      <td>{{codeTask.assignedTo}}</td>
      <td>{{getCategoryName(codeTask)}}</td>
      <td>{{getStatusName(codeTask)}}</td>
      <td>{{getPriorityName(codeTask)}}</td>
      <td>{{formateDate(codeTask.assignedDate)}}</td>
      <td>{{formateDate(codeTask.completedDate)}}</td>
      <td>{{codeTask.hours}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(codeTask)"></i>
        </a>
      </span>
    </td>
  </tr>
}
@if (!codeProjectId) {
  <tr [pSelectableRow]="codeTask">
    <td>{{codeTask.taskName}}</td>
    <td>{{codeTask.assignedTo}}</td>
    <td>{{getCategoryName(codeTask)}}</td>
    <td [style.background-color]="getResStatusColor(codeTask.status)">{{getStatusName(codeTask)}}</td>
    <td>{{getPriorityName(codeTask)}}</td>
    <td>{{formateDate(codeTask.assignedDate)}}</td>
    <td>{{formateDate(codeTask.completedDate)}}</td>
    <td>{{codeTask.hours}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(codeTask)"></i>
      </a>
    </span>
  </td>
</tr>
}
</ng-template>
</p-table>